export default __webpack_public_path__ + "static/media/gauge-good.2a5e6f3a.png";